// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/TestTiemposHeadline-Regular-BF66457a508e31a.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "TiemposHeadline";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

.portfolio-section {
  padding: 10rem;
  text-align: center;
  font-size: 20px;
  font-family: "TiemposHeadline", sans-serif;
}

.portfolio-items {
  display: flex;
  flex: 1 1;
  justify-content: center;
  gap: 2rem;
}

.portfolio-item {
  padding: 3rem;
}

.internship {
  flex: 1 1;
  height: 23rem;
}

.internship-text {
  width: 26rem;
  text-align: left;
  padding-left: 1rem;
}

.project-name {
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
}

.project-description {
  font-size: 1rem;
  font-family: "system-ui", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Internships.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAO;EACP,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC","sourcesContent":["@font-face {\n  font-family: \"TiemposHeadline\";\n  src: url(\"../assets/TestTiemposHeadline-Regular-BF66457a508e31a.otf\")\n    format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.portfolio-section {\n  padding: 10rem;\n  text-align: center;\n  font-size: 20px;\n  font-family: \"TiemposHeadline\", sans-serif;\n}\n\n.portfolio-items {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  gap: 2rem;\n}\n\n.portfolio-item {\n  padding: 3rem;\n}\n\n.internship {\n  flex: 1;\n  height: 23rem;\n}\n\n.internship-text {\n  width: 26rem;\n  text-align: left;\n  padding-left: 1rem;\n}\n\n.project-name {\n  font-size: 1.3rem;\n  margin-bottom: 0.5rem;\n}\n\n.project-description {\n  font-size: 1rem;\n  font-family: \"system-ui\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
